import { Outlet } from 'react-router-dom';
import BottomNav from './BottomNav';

export default function AppShell() {
  return (
    <div className="min-h-screen bg-dark-950 text-white pb-20">
      <Outlet />
      <BottomNav />
    </div>
  );
}
